import React, { useMemo } from 'react';
import { AppWidth, DocWidth, Flex, Link, P } from '@tpr/core';
import style from './beta.module.scss';
export var BetaHeader = function (_a) {
    var text = _a.text, mail = _a.mail;
    var TextComponent = useMemo(function () {
        return function () { return (React.createElement(P, { cfg: { fontSize: 2, color: 'neutral.8', my: 1 } }, text ? (text) : (React.createElement(React.Fragment, null,
            "This is a new service \u2014 your",
            ' ',
            React.createElement(Link, { href: mail
                    ? "mailto:" + (mail.email || '') + "&subject=" + (mail.subject || '')
                    : 'mailto:' }, "feedback"),
            ' ',
            "will help us improve it.")))); };
    }, [text, mail]);
    return (React.createElement(DocWidth, { className: style.beta },
        React.createElement(AppWidth, null,
            React.createElement(Flex, { cfg: { alignItems: 'center', px: 6 } },
                React.createElement(P, { cfg: {
                        fontSize: 2,
                        fontWeight: 4,
                        color: 'white',
                        bg: 'primary.3',
                        p: 2,
                        my: 2,
                        mr: 3,
                    } }, "BETA"),
                React.createElement(TextComponent, null)))));
};
//# sourceMappingURL=beta.js.map